import session from './session';
import settings from './settings';

const permissions = {
    getAll: () => {
        return settings.getValue('permissions', null);
    },
    getPerm: (perm) => {
        var perms = settings.getValue('permissions', null);
        if (perms) {
            if (perm in perms) {
                return perms[perm];
            }
        }
        return null;
    },
    getTaggingModels: () => {
        var perms = settings.getValue('permissions', null);
        if (perms) {
            if ('taggingModels' in perms) {
                return perms['taggingModels'];
            }
        }
        return [];
    },
    getIATaggingModels: () => {
        var perms = settings.getValue('permissions', null);
        if (perms) {
            if ('taggingModels' in perms) {
                var models = perms['taggingModels'];
                return models.filter((mod) => {return mod != 'naics'});
            }
        }
        return [];
    },
    checkEndpoint: (endpoint, features=null) => {
        var perms = settings.getValue('permissions', null);
        var auth = false;
        if (perms) {
            if ('endpoints' in perms) {
                auth = perms['endpoints'].indexOf(endpoint) != -1 ? true : false
                if (auth) {
                    if (features && features.length > 0) {
                        if ('features' in perms) {
                            for (const feat of features) {
                                auth = perms['features'].indexOf(feat) != -1 ? true : false
                                if (!auth) {
                                    break;
                                }
                            }
                        } else {
                            auth = false;
                        }
                    }
                }
            }   
        } 
        return auth;
    },
    checkTaggingModel: (model) => {
        var perms = settings.getValue('permissions', null);
        var auth = false;
        if (perms) {
            if ('taggingModels' in perms) {
                auth = perms['taggingModels'].indexOf(model) != -1 ? true : false
            }   
        } 
        return auth;
    }
};

export default permissions;
